import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import { createEcho } from "./echo";

const token = localStorage.getItem("token");

if (token) {
    window.Echo = createEcho(token);
}

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault("America/New_York");

// Get the current domain (hostname) from the browser's address bar
const hostname = window.location.hostname;
let titleSuffix = "";

if (hostname.includes("portalsavannah")) {
    titleSuffix = "Savannah";
} else if (hostname.includes("portalhouston")) {
    titleSuffix = "Houston";
} else if (hostname.includes("portalnewyork")) {
    titleSuffix = "New York";
} else {
    titleSuffix = "Local";
}

document.title = `CTrade / ${titleSuffix}`;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ConfigProvider
        theme={{
            token: {
                colorPrimary: "#B83D3D",
                fontFamily: 'Poppins',
                fontSize: 12.5
            },
            components: {
                Table: {
                    fontSize: 11.5,
                    fontFamily: 'Poppins',
                    headerSplitColor: 'transparent',
                    headerSplitColor: 'transparent',
                },
            }
        }}>
        <App />

    </ConfigProvider>

);
reportWebVitals();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
